module.exports = __webpack_public_path__ + "img/installing_Into_wall_w_wedge_wired.95876aaa.png";